import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Lang, Roles, UserRoles } from 'cdx-common';
import { CompanyLoader } from '../AppItems';


const RoleItem = (props: { userRole: UserRoles; }) => {

    if (props.userRole.role === Roles.CUSTOMER) {
        return <CompanyLoader id={props.userRole.relatedId} render={company => <>{Lang('roles.' + props.userRole.role) + ' ' + company.name}</>} />;
    } else {
        return <>{Lang('roles.' + props.userRole.role)}</>;
    }
};


export const UserRoleGridItem = (props: GridRenderCellParams<any>) => {
    return props.value.map((p: UserRoles) => <RoleItem userRole={p} />);
};
